import { createAction, props } from "@ngrx/store";
import {
  RoomStreamActiveDeleteCmd,
  RoomStreamActiveSetCmd,
  RoomStreamAudioUpdateCmd,
  RoomStreamDeleteCmd,
  RoomStreamRestartCmd
} from "@youm-front/room/domain";

export const roomStreamActiveDelete = createAction(
  "[Room] Room Stream Active Delete",
  props<{
    roomStreamActiveDeleteCmd: RoomStreamActiveDeleteCmd;
  }>()
);
export const roomStreamActiveDeleteSuccess = createAction(
  "[Room] Room Stream Active Delete Success",
  props<{ roomStreamActiveDeleteCmd: RoomStreamActiveDeleteCmd }>()
);
export const roomStreamActiveDeleteFailure = createAction(
  "[Room] Room Stream Active Delete Failure",
  props<{
    error: string;
  }>()
);

export const roomStreamActiveSet = createAction(
  "[Room] Room Stream Active Set",
  props<{
    roomStreamActiveSetCmd: RoomStreamActiveSetCmd;
  }>()
);
export const roomStreamActiveSetSuccess = createAction(
  "[Room] Room Stream Active Set Success",
  props<{ roomStreamActiveSetCmd: RoomStreamActiveSetCmd }>()
);
export const roomStreamActiveSetFailure = createAction(
  "[Room] Room Stream Active Set Failure",
  props<{
    error: string;
  }>()
);

export const roomStreamAudioUpdate = createAction(
  "[Room] Room Stream Audio Update",
  props<{ roomStreamAudioUpdateCmd: RoomStreamAudioUpdateCmd }>()
);
export const roomStreamAudioUpdateSuccess = createAction(
  "[Room] Room Stream Audio Update Success",
  props<{ roomStreamAudioUpdateCmd: RoomStreamAudioUpdateCmd }>()
);
export const roomStreamAudioUpdateFailure = createAction(
  "[Room] Room Stream Audio Update Failure",
  props<{
    error: string;
  }>()
);

export const roomStreamDelete = createAction(
  "[Room] Room Stream Delete",
  props<{ roomStreamDeleteCmd: RoomStreamDeleteCmd }>()
);
export const roomStreamDeleteSuccess = createAction(
  "[Room] Room Stream Delete Success",
  props<{ roomStreamDeleteCmd: RoomStreamDeleteCmd }>()
);
export const roomStreamDeleteFailure = createAction(
  "[Room] Room Stream Delete Failure",
  props<{
    error: string;
  }>()
);

export const roomStreamRestart = createAction(
  "[Room] Room Stream Restart",
  props<{ roomStreamRestartCmd: RoomStreamRestartCmd }>()
);
export const roomStreamRestartSuccess = createAction(
  "[Room] Room Stream Restart Success",
  props<{ roomStreamRestartCmd: RoomStreamRestartCmd }>()
);
export const roomStreamRestartFailure = createAction(
  "[Room] Room Stream Restart Failure",
  props<{
    error: string;
  }>()
);
